export default __webpack_public_path__ + "static/cafe_36035-43503d60f70b9c0154607dcea1e9f6ad.png";